export const taxContact = {
  title : "contact_tax_title",
  description: "contact_tax_description"
}